





















































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import ListEosWholesales from '@/views/wholesale/ListEosWholesales.vue';
import {EOS卸型, 卸初期値, 卸型} from '@/type/wholesale/wholesale';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import {発注単位区分型, 発注有効区分値} from '@/type/wholesale/types';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import SlipLineNoField from '@/components/atom/input/SlipLineNoField.vue';

@Component({
  components: {
    ListEosWholesales,
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    AlertDialog,
    SlipLineNoField,
  },
})

export default class RegisterWholesale extends Vue {

  private 卸登録: 卸型 = 卸初期値;
  private 発注単位区分リスト: string[] = [
    発注単位区分型.箱,
    発注単位区分型.バラ,
  ];
  private アラートメッセージ: string[] = [];
  private eosModal: boolean = false;

  @Prop({default: false})
  private modal!: boolean;

  public created(): void {
    this.init();
  }

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal) {
      this.openDialog('卸マスタ新規画面');
    }
  }

  @Emit('close-form')
  private closeForm(): void {
    this.clear();
    this.closeDialog('卸マスタ新規画面');
  }

  @Watch('卸登録.備蓄品発注有効区分')
  private watchStockpile() {
    if (this.卸登録.備蓄品発注有効区分 === 発注有効区分値.有効) {
      this.卸登録.医薬品発注有効区分 = 発注有効区分値.無効;
      this.卸登録.その他品発注有効区分 = 発注有効区分値.無効;
    }
  }

  @Watch('卸登録.医薬品発注有効区分')
  private watchMedicine() {
    if (this.卸登録.医薬品発注有効区分 === 発注有効区分値.有効) {
      this.卸登録.備蓄品発注有効区分 = 発注有効区分値.無効;
    }
  }

  @Watch('卸登録.その他品発注有効区分')
  private watchOther() {
    if (this.卸登録.その他品発注有効区分 === 発注有効区分値.有効) {
      this.卸登録.備蓄品発注有効区分 = 発注有効区分値.無効;
    }
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private registerHandler(): void {
    progress(this.register);
  }

  private async register(): Promise<void> {
    await api.卸を登録する(this.卸登録)
      .then(
        () => {
          this.closeDialog('確定ダイアログ');
          this.closeForm();
        },
        (error: any) => {
          this.closeDialog('確定ダイアログ');
          if (error.data.errors) {
            this.アラートメッセージ = error.data.errors;
          }
          if (error.data.message && !error.data.errors) {
            this.アラートメッセージ = [error.data.message];
          }
          this.openDialog('卸登録アラート');
        },
      );
  }

  private clear(): void {
    this.init();
    this.closeDialog('クリアダイアログ');
  }

  private init(): void {
    this.卸登録 = {...卸初期値};
    this.卸登録.備蓄センターフラグ = null;
    this.卸登録.医薬品発注有効区分 = '有効';
    this.卸登録.その他品発注有効区分 = '有効';
    this.卸登録.備蓄品発注有効区分 = '無効';
    this.アラートメッセージ = [];
  }

  private closeEosWholesales(): void {
    this.eosModal = false;
  }

  private openEosWholesales(): void {
    this.eosModal = true;
  }

  private selectWholesale(EOS卸: EOS卸型): void {
    this.卸登録.EOS卸コード = EOS卸.EOS卸コード;
    this.卸登録.EOS卸サブコード = EOS卸.EOS卸サブコード;
    this.卸登録.卸名 = EOS卸.卸名;
    this.卸登録.卸名カナ = EOS卸.卸名カナ;
    this.卸登録.備蓄センターフラグ = EOS卸.備蓄センターフラグ;
    this.卸登録.納品予定指定可能日数 = EOS卸.納品予定指定可能日数;
    this.卸登録.複写フラグ = '複写あり';
    if (EOS卸.備蓄センターフラグ === '備蓄センター') {
      this.卸登録.備蓄品発注有効区分 = '有効';
      this.卸登録.発注単位区分 = 'バラ';
    }
    if (EOS卸.備蓄センターフラグ === '備蓄センター以外') {
      this.卸登録.医薬品発注有効区分 = '有効';
      this.卸登録.その他品発注有効区分 = '有効';
      this.卸登録.発注単位区分 = '箱';
    }
    this.closeEosWholesales();
  }

  private get isMaster(): boolean {
    return loginModule.マスターである;
  }

  private get isEOS(): boolean {
    if (this.卸登録.EOS卸コード == null) {
      return false;
    }
    return this.卸登録.EOS卸コード !== '';
  }
}
